<template lang="pug">
.home.full-height
  load-manager.scrollable(:loading="loading")
    .container.grid-lg
      .h5 Destaques
      .columns
        .column.mb-2(v-for="resumo in resumos", :key="resumo.id")
          .p-2.mb-2.bg-white.s-rounded.box-shadow.destaque
            .tile.tile-centered.c-hand(@click="navigateTo(resumo)")
              .tile-icon.text-primary
                i.centered.fa(:class="icon[resumo.id]")
              .tile-content
                .tile-title.h5 {{ resumo.title }}
                b.count(v-if="resumo.count > 0") {{ resumo.count }} &nbsp;
                small.tile-subtitle {{ resumo.message }}
              .tile-action
                i.fa.fa-chevron-right.text-primary
      .h5.mt-5 Mais opções
      .card.c-hand.box-shadow.mb-2(v-if="info && info.ouvidoria" @click="navigateTo({ id: 'ouvidoria' })")
        .card-body
          .columns
            .column.col-auto
              img.img-responsive.img-cadastro(
                alt="Ouvidoria",
                src="@/assets/ouvidoria-banner.png"
              )
            .column
              i.float-right.fa.fa-chevron-right.text-primary
              .card-title.h5 Ouvidoria
              .card-subtitle &nbsp;
              .card-subtitle Abra chamados para a prefeitura
      .card.c-hand.box-shadow.mb-2(@click="navigateTo({ id: 'cadastros' })")
        .card-body
          .columns
            .column.col-auto
              img.img-responsive.img-cadastro(
                alt="Cadastro",
                src="@/assets/cadastro-banner.png"
              )
            .column
              i.float-right.fa.fa-chevron-right.text-primary
              .card-title.h5 Cadastros
              .card-subtitle &nbsp;
              .card-subtitle Consulte os cadastros no município
      .columns
        .column.col-6.col-sm-12.mb-2(v-for="item in subItems", :key="item.id")
          .card.c-hand.box-shadow(@click="navigateTo(item)")
            .card-header
              i.float-right.fa.fa-chevron-right.text-primary
              .h5
                i.text-primary(:class="item.icon")
                span.ml-1 {{ item.label }}
            .card-body {{ item.info }}
</template>

<script>
import toastErrors from "@/lib/errors/toastErrors";
import { LocalStorageFacade } from "paliari-js-utils";

export default {
  vuex: {
    info: {
      state: { info: "current" },
    },
    resumos: {
      state: ["resumos"],
      actions: ["fetchResumos"],
      getters: ["loading"],
    },
  },
  computed: {
    icon() {
      return {
        validacaoConta: "fa fa-unlock-alt fa-2x",
        notasRecebidas: "fa fa-file-text-o fa-2x",
        mensagens: "fa fa-envelope-o fa-2x",
        documentos: "fa fa-flag-o fa-2x",
      };
    },
    subItems() {
      return [
        {
          id: "documentos",
          icon: "fa fa-flag-o fa-lg",
          label: "Documentos",
          info: "Consulte os Documentos recebidos no município",
        },
        {
          id: "mensagens",
          icon: "fa fa-envelope-o fa-lg",
          label: "Mensagens",
          info: "Consulte as suas mensagens",
        },
        {
          id: "notasRecebidas",
          icon: "fa fa-file-text-o fa-lg",
          label: "Notas recebidas",
          info: "Consulte as Notas de Serviços recebidas no município",
        },
        {
          id: "carnes",
          icon: "fa fa-barcode fa-lg",
          label: "IPTU",
          info: "Consulte os carnês de IPTU no município",
        },
      ];
    },
  },
  methods: {
    navigateTo(resumo) {
      this.$router.push({
        name: `app.${resumo.id}`,
        query: { scope: resumo.scope },
      });
    },
  },
  async created() {
    if (!this.resumos.length) {
      try {
        await this.fetchResumos();
      } catch (e) {
        toastErrors(e);
      }
    }
    if (LocalStorageFacade.getItem("nextRoute")) {
      const route = LocalStorageFacade.getItem("nextRoute");
      LocalStorageFacade.removeItem("nextRoute");
      if (route && route.name !== "app.home") {
        return this.$router.push(route);
      }
    }
  },
};
</script>

<style lang="stylus" scoped>
.card, .destaque {
  height: 100%;
}

.img-cadastro {
  max-height: 250px;
  margin: 0 auto;
}
</style>
